import { connect } from 'react-redux';
import { push } from "react-router-redux";
import { getUser } from '../redux/actions/AccountSetting';
import { getUser as getUserSelector } from '../redux/selectors/accountSettingSelector';
import * as actions from '../redux/actions/LetterCorrection';
import LetterCorrection from '../components/LetterCorrection/LetterCorrection';

const mapStateToProps = (state) => {
  return {
    pathname: state.router.location.pathname,
    user: getUserSelector(state),
    isCorrecting: state.letterCorrection.isCorrecting,
    correctedContents: state.letterCorrection.correctedContents,
    successMessage: state.letterCorrection.successMessage,
    errorMessage: state.letterCorrection.errorMessage,
    shortMessage: state.letterCorrection.shortMessage,
  };
};

const mapDispatchToProps = dispatch => ({
  goTo(url, state) {
    dispatch(push(url, state));
  },

  getUserInfo() {
    dispatch(getUser());
  },

  postCorrect(data) {
    dispatch(actions.postCorrect(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(LetterCorrection);



// WEBPACK FOOTER //
// ./src/containers/LetterCorrection.js